var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHojaazul(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 91,
    viewBox: "0 0 70 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6583 2.66349e-09C30.5955 0.245961 29.5515 0.613102 28.5452 1.10142C11.1495 9.54265 0 33.1475 0 53.376C0 72.5972 13.9009 88.3874 31.6583 90.1321V2.66349e-09Z",
    fill: "#151B4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2083 90.1321C55.9658 88.3874 69.8667 72.5972 69.8667 53.376C69.8667 51.5354 69.7744 49.6668 69.5934 47.7842L38.2083 80.3672V90.1321Z",
    fill: "#151B4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2673 23.1067C60.5689 19.8208 58.6105 16.7079 56.4172 13.8634L38.2083 32.7672V48.0839L62.2673 23.1067Z",
    fill: "#151B4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0002 8.83231C48.7896 5.63523 45.2117 2.98915 41.3215 1.10142C40.3151 0.613102 39.2712 0.245961 38.2083 0V23.1506L52.0002 8.83231Z",
    fill: "#151B4E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2224 29.6554L38.2083 57.7006V70.7506L67.6833 40.1506L68.2594 39.5525C67.4999 36.2083 66.4808 32.8836 65.2224 29.6554Z",
    fill: "#151B4E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHojaazul);
export default __webpack_public_path__ + "static/media/hojaazul.8f52eeed4471058484ed4493945e0a15.svg";
export { ForwardRef as ReactComponent };